const PROJECT_ID = import.meta.env.VITE_CLARITY_PROJECT_ID as string | undefined;
const ENVIRONMENT =
  (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) ||
  import.meta.env.MODE;

type ClarityFn = (...args: unknown[]) => void;
interface ClarityFnWithQueue extends ClarityFn {
  q?: unknown[][];
}

type ClarityWindow = Window & { clarity?: ClarityFnWithQueue };

function getClarity(): ClarityFnWithQueue | undefined {
  return (window as ClarityWindow).clarity;
}

export function initClarity(): void {
  if (!PROJECT_ID) return;
  // Dev local nunca grava — evita expor sessões de desenvolvimento ao dashboard.
  if (import.meta.env.DEV) return;

  const win = window as ClarityWindow;
  if (!win.clarity) {
    const stub: ClarityFnWithQueue = (...args: unknown[]) => {
      (stub.q = stub.q || []).push(args);
    };
    win.clarity = stub;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${PROJECT_ID}`;
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript?.parentNode?.insertBefore(script, firstScript);

  // Tag de ambiente vai na fila do stub antes do script real carregar;
  // o Clarity processa a fila no boot. Útil pra filtrar sessões por env
  // no dashboard quando STG e PROD coexistirem.
  win.clarity('set', 'environment', ENVIRONMENT);
}

export function identifyClarityUser(userId: string, friendlyName?: string): void {
  // API: clarity('identify', custom-id, custom-session-id?, custom-page-id?, friendly-name?)
  // friendly-name aparece como filtro legível no painel do Clarity em vez de
  // só o UUID. Cuidado com PII — em prod, considerar mascarar/encurtar.
  const clarity = getClarity();
  if (!clarity) return;
  if (friendlyName) {
    clarity('identify', userId, undefined, undefined, friendlyName);
  } else {
    clarity('identify', userId);
  }
}

export function setClarityTag(key: string, value: string): void {
  getClarity()?.('set', key, value);
}
